import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  DriverReq,
  DriverReqsData,
  DriverReqsParams,
  PassengerReqsData,
  PassengerReqsParams, PassengerRequest, ServiceMirandaData
} from '../interfaces/miranda.interface';


function getValueObj<T, K extends keyof T>(obj: T, key: K): T[K] {
  return obj[key];
}

@Injectable({
  providedIn: 'root'
})
export class MirandaApiService {

  constructor(private http: HttpClient) {}

  public getPassengerReq(par: PassengerReqsParams): Observable<PassengerReqsData> {
    let params = new HttpParams();
    for (const key in par) {
      params = params.set(key, String(par[key as keyof typeof par]));
    }
    return this.http.get<PassengerReqsData>(`mirandaHttp/client/api/v1/passenger/requests/history/all`, {params});
  }

  public getDriverReqOne(id: string): Observable<{data: DriverReq}> {
    return this.http.get<{data: DriverReq}>(`mirandaHttp/123456/driver/archive/request`, {params: {id}});
  }

  public getOperatorServices(): Observable<ServiceMirandaData> {
    return this.http.get<ServiceMirandaData>(`mirandaHttp/client/operator/accessible/services`);
  }

  public getOperatorTranslation(): Observable<any> {
    return this.http.get<any>(`mirandaHttp/client/operator/localization/translations/common/url`);
  }

  public getUniversal(url: string): Observable<any> {
    return this.http.get<any>(url);
  }

  public getPassengerReqOne(id: string, service_id: string): Observable<{data: PassengerRequest}> {
    return this.http.get<{data: PassengerRequest}>(`mirandaHttp/client/api/v1/passenger/requests/support-details`, {params: {id, service_id}});
  }

  public getDriverReq(par: DriverReqsParams): Observable<DriverReqsData> {
    let params = new HttpParams();
    for (const key in par) {
      params = params.set(key, String(par[key as keyof typeof par]));
    }
    return this.http.get<DriverReqsData>(`mirandaHttp/123456/driver/archive`, {params});
  }
}
